import { render, staticRenderFns } from "./StudyAndJudge.vue?vue&type=template&id=75526a0a&scoped=true&"
import script from "./StudyAndJudge.vue?vue&type=script&lang=js&"
export * from "./StudyAndJudge.vue?vue&type=script&lang=js&"
import style0 from "./StudyAndJudge.vue?vue&type=style&index=0&id=75526a0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75526a0a",
  null
  
)

export default component.exports